import React, { useState } from "react";

export default function ContactPromptCard() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setEmail("");
    setMessage("");
  };

  return (
    <div className="container">
      <div className="contact-prompt-card">
        <h5>Still have a question?</h5>
        <form onSubmit={handleSubmit}>
          <label className="form-field-label">Enter email</label>
          <input
            type="email"
            className="form-field-input"
            placeholder="General Inquiry / Partnership / Support / Press"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="form-field-label">Message</label>
          <textarea
            className="form-field-input"
            rows={4}
            placeholder="Tell us how we can help..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />

          <button type="submit" className="btn-mu-solid mt-2" style={{ width: "auto" }}>
            {sent ? "✓ Message Sent" : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
